module.exports = __webpack_public_path__ + "img/jxb.e1d5dca7.svg";